export enum REGIONS {
  AMERICA = 'us-central1',
  EUROPE = 'europe-west1',
  ASIA = 'asia-east1'
}